var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"paddingLargeRight paddingLargeLeft"},[_c('div',{staticClass:"minorTitle"},[_vm._v("\n    Create an Account\n  ")]),_vm._v(" "),_c('div',{staticClass:"accountMenuFullHeightContainer"},[_c('CreateAccount')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }